<script setup>
import { computed, inject } from 'vue';

const props = defineProps({
  index: {
    type: Number,
    default: 0,
  },
  name: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  count: {
    type: Number,
    default: 0,
  },
  showBadge: {
    type: Boolean,
    default: true,
  },
  isCompact: {
    type: Boolean,
    default: false,
  },
});

const activeIndex = inject('activeIndex');
const updateActiveIndex = inject('updateActiveIndex');

const active = computed(() => props.index === activeIndex.value);
const getItemCount = computed(() => props.count);

const onTabClick = event => {
  event.preventDefault();
  if (!props.disabled) {
    updateActiveIndex(props.index);
  }
};
</script>

<template>
  <li class="flex-shrink-0 my-0" :class="isCompact ? 'h-8' : 'h-9'">
    <a
      class="inline-flex h-[calc(100%+1px)] -mb-px items-center gap-1.5 border-b-2 border-solid px-0 type-polaris-label whitespace-nowrap select-none cursor-pointer"
      :class="[
        active
          ? 'border-polaris-foreground text-polaris-foreground'
          : 'border-transparent text-polaris-muted-foreground hover:text-polaris-foreground',
      ]"
      @click="onTabClick"
    >
      {{ name }}
      <div
        v-if="showBadge"
        class="rounded-full bg-polaris-muted h-5 flex items-center justify-center text-polaris-muted-foreground tabular-nums type-polaris-caption my-0 ltr:ml-1 rtl:mr-1 px-1.5 py-0 min-w-[20px]"
      >
        <span>
          {{ getItemCount }}
        </span>
      </div>
    </a>
  </li>
</template>
